// src/pages/ResetPasswordPage.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
const STRAPI_URL = process.env.REACT_APP_STRAPI_URL;

export default function ResetPasswordPage() {
  const [code, setCode] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  const [status, setStatus] = useState('');

  useEffect(() => {
    const p = new URLSearchParams(window.location.search);
    setCode(p.get('code') || '');
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setStatus('');
    try {
      await axios.post(`${STRAPI_URL}/api/auth/reset-password`, {
        code, password, passwordConfirmation,
      });
      setStatus('Je wachtwoord is gewijzigd. Je kunt nu inloggen.');
    } catch (err) {
      setStatus('Een nieuw wachtwoord instellen lukte niet. Misschien is de link verlopen.');
    }
  };

  return (
    <div className="page-container">
      <main style={{ padding: '2rem' }}>
        <h1>Wachtwoord resetten</h1>
        {!code ? (
          <p>Ongeldige of ontbrekende resetcode.</p>
        ) : (
          <form onSubmit={submit} style={{ maxWidth: 420 }}>
            <div className="form-group">
              <label>Nieuw wachtwoord</label>
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
            </div>
            <div className="form-group">
              <label>Bevestig nieuw wachtwoord</label>
              <input type="password" value={passwordConfirmation} onChange={(e) => setPasswordConfirmation(e.target.value)} required />
            </div>
            {status && <p className="info-message">{status}</p>}
            <button type="submit" className="btn-primary">Wijzig wachtwoord</button>
          </form>
        )}
      </main>
    </div>
  );
}
